import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../css/Formulario.css';
import { LinearProgress, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, FormHelperText } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CampoForm from '../components/CampoForm';
import { conseguirDatoAValidar, validateFormContent } from '../utils/Funcs';


const Formulario = () => {
    const pasosMaximos = 5; // Cambia esto al número total de preguntas
    const [step, setStep] = useState(1);
    const [errorMessage, setErrorMessage] = useState(''); // Estado para el mensaje de error
    const [formData, setFormData] = useState({
        nombre: '',
        telefono: '',
        correo: '',
        ubicacion: '',
        titular: '',
        marca: '',
        modelo: '',
        anio: '',
        version: '',
        km: '',
        patente: '',
        estado: ''
    });

    // Variantes para las animaciones de avance y retroceso
    const variants = {
        enter: (direction) => ({
            opacity: 0,
            y: direction === 1 ? 50 : -50,  // Aparece desde arriba (retroceso) o abajo (avance)
        }),
        center: {
            opacity: 1,
            y: 0,
        },
        exit: (direction) => ({
            opacity: 0,
            y: direction !== 1 ? -50 : 50,  // Sale hacia arriba (avance) o abajo (retroceso)
        }),
    };

    const handleNext = (e) => {
        e.preventDefault();  // Prevenir la recarga de la página
        if (validateFormContent(verificaciones[step-1], conseguirDatoAValidar(step, formData), setErrorMessage)) {
            setErrorMessage(''); // Limpiar mensaje de error
            setStep(step + 1);
        }
    };
    
    const handleEnter = (e) => {
        if (e.key === 'Enter') {
            handleNext(e);
        }
        if (e.key === 'Escape') {
            handleBack(e);
        }
    };

    const handleBack = (e) => {
        e.preventDefault();  // Prevenir la recarga de la página
        setErrorMessage("")
        setStep(step - 1);
    };
    
    const handlePost = (e) => {
        e.preventDefault();  // Prevenir la recarga de la página
        console.log(formData)
    };

    const PREGUNTASFORMULARIO = [
        <CampoForm
            label={"Nombre y Apellido"}
            value={formData.nombre}
            funcionalidad={(e) => {setFormData({ ...formData, nombre: e.target.value }); validateFormContent(1, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
            pasos={step}
        />,
        <CampoForm
            pasos={step}
            label={"Número de Teléfono"}
            value={formData.telefono}
            type='number'
            funcionalidad={(e) => {setFormData({ ...formData, telefono: Number(e.target.value) }); validateFormContent(2, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <CampoForm
            pasos={step}
            label={"Correo electrónico"}
            value={formData.correo}
            funcionalidad={(e) => {setFormData({ ...formData, correo: e.target.value }); validateFormContent(3, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <CampoForm
            pasos={step}
            label={"¿En dónde se encuentra? Localidad, Barrio, Partido."}
            value={formData.ubicacion}
            funcionalidad={(e) => {setFormData({ ...formData, ubicacion: e.target.value }); validateFormContent(1, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <FormControl component="fieldset">
            <FormLabel component="legend">¿Usted es titular del auto?</FormLabel>
            <RadioGroup
                aria-label="titular"
                name="titular"
                value={formData.titular}
                onChange={(e) => setFormData({ ...formData, titular: e.target.value })}
            >
                <FormControlLabel value={true} control={<Radio color="success" />} label="Sí" />
                <FormControlLabel value={false} control={<Radio color="success" />} label="No" />
            </RadioGroup>
            {errorMessage && <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>}
        </FormControl>,
        <CampoForm
            pasos={step}
            label={"Marca del Auto"}
            value={formData.marca}
            funcionalidad={(e) => {setFormData({ ...formData, marca: e.target.value }); validateFormContent(1, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <CampoForm
            pasos={step}
            label={"Modelo del auto"}
            value={formData.modelo}
            funcionalidad={(e) => {setFormData({ ...formData, modelo: e.target.value }); validateFormContent(1, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <CampoForm
            pasos={step}
            label={"Año del auto"}
            value={formData.anio}
            type='number'
            funcionalidad={(e) => {setFormData({ ...formData, anio: Number(e.target.value) }); validateFormContent(5, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <CampoForm
            pasos={step}
            label={"Versión"}
            value={formData.version}
            funcionalidad={(e) => {setFormData({ ...formData, version: e.target.value }); validateFormContent(1, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <CampoForm
            pasos={step}
            label={"Kilometros"}
            value={formData.km}
            type='number'
            funcionalidad={(e) => {setFormData({ ...formData, km: Number(e.target.value) }); validateFormContent(6, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        // <CampoForm
        //     pasos={step}
        //     label={'Patente (sin espacios ni "-")'}
        //     value={formData.patente}
        //     funcionalidad={(e) => {setFormData({ ...formData, patente: e.target.value }); validateFormContent(7, e.target.value, setErrorMessage)}}
        //     errorMessage={errorMessage}
        //     enterKey={handleEnter}
        // />,
        <FormControl component="fieldset">
            <FormLabel component="legend">Estado del auto</FormLabel>
            <RadioGroup
                aria-label="estado"
                name="estado"
                value={formData.estado}
                onChange={(e) => setFormData({ ...formData, estado: Number(e.target.value) })}
            >
                <FormControlLabel value={0} control={<Radio color="success" />} label="Excelente" />
                <FormControlLabel value={1} control={<Radio color="success" />} label="Muy bueno" />
                <FormControlLabel value={2} control={<Radio color="success" />} label="Bueno" />
                <FormControlLabel value={3} control={<Radio color="success" />} label="Malo" />
            </RadioGroup>
            {errorMessage && <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>}
        </FormControl>,
    ]
    const verificaciones = [1, 2, 3, 1, 4, 1, 1, 5, 1, 6, 4]

    const progress = ((step - 1) / (PREGUNTASFORMULARIO.length)) * 100;

    return (
        <div className='pagina-entera'>
            <LinearProgress variant="determinate" value={progress} color='success' />
            <img src={`${process.env.PUBLIC_URL}/images/IconoDelta-cortado.png`} alt="Banner de la concesionaria" className='icono-logo'/>
            <p className='titulo_form'>Quiero Vender</p>

            <div className="formulario-container">
                <AnimatePresence mode="wait" custom={step}>
                    <motion.form 
                        key={step}  // Necesario para que AnimatePresence funcione correctamente
                        custom={step > 1 ? 1 : -1}  // Determina la dirección de la animación
                        initial="enter"
                        animate="center"
                        exit="exit"
                        variants={variants}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="question">
                            {PREGUNTASFORMULARIO[step-1]}
                        </div>

                    </motion.form>
                </AnimatePresence>
            </div>
            <div className="botones-container">
                {step > 1 && <button onClick={handleBack} className='button-back'><ArrowBackIosIcon/></button>}
                {step!==PREGUNTASFORMULARIO.length && <button onClick={handleNext} className='button-forw'><ArrowForwardIosIcon/></button>}
                {step===PREGUNTASFORMULARIO.length && <button onClick={() => window.location.href = './fin'} className='button-forw'>ENVIAR</button>}
                {/* <button onClick={(e)=> {e.preventDefault(); console.log(formData);}}>printear</button> */}
            </div>
            
        </div>
    );
};

export default Formulario;
